import {
  Code,
  LayoutGrid,
  Database,
  Wrench,
  Cloud,
  Briefcase,
  Calendar,
  MapPin,
  Video,
  Receipt,
  Dumbbell,
  Github,
  Linkedin,
  Mail,
  Phone,
  ExternalLink,
  ArrowRight,
  ChevronDown,
} from "lucide-react";

export const personalInfo = {
  name: "Aditya Aman",
  title: "Full Stack MERN Developer",
  tagline: "Building scalable web applications with 3.5+ years of experience",
  email: "adityaaman22@gmail.com",
  phone: "+91 9155524308",
  linkedin: "https://www.linkedin.com/in/aditya-aman-b27708152",
  github: "https://github.com/maverick-adi",
  location: "India",
  yearsOfExperience: 3.5,
  projectsCompleted: 15,
  resumeUrl: "https://customer-assets.emergentagent.com/job_mern-dev-aditya/artifacts/c8sd3ge5_Aditya_resume.pdf",
  openToWork: "✦ Open to Work — Immediate Joiner",
  availability: "Available for Full-Time Roles · Remote / On-site · Expected CTC: 10 LPA",
};

export const aboutMe = {
  description:
    "Results-driven Full Stack Developer with 3.5 years of experience in full-stack web development, API design, and performance optimization. Adept at building scalable applications and collaborating with cross-functional teams.",
  highlights: [
    "3.5+ years of professional experience",
    "End-to-end project delivery",
    "Performance optimization specialist",
    "Cross-functional team collaboration",
  ],
};

export const skillCategories = [
  {
    title: "Languages",
    icon: "Code",
    skills: ["JavaScript", "TypeScript", "HTML", "CSS", "Java"],
  },
  {
    title: "Frameworks",
    icon: "LayoutGrid",
    skills: [
      "React.js",
      "Next.js",
      "Redux",
      "Node.js",
      "Express.js",
      "NestJS",
      "REST APIs",
      "Spring Boot",
    ],
  },
  {
    title: "Database",
    icon: "Database",
    skills: ["MongoDB", "MySQL", "PostgreSQL"],
  },
  {
    title: "Libraries & Tools",
    icon: "Wrench",
    skills: ["Material UI", "Redux", "Google Maps", "Firebase", "PayU"],
  },
  {
    title: "Cloud & DevOps",
    icon: "Cloud",
    skills: [
      "Docker",
      "AWS EC2",
      "AWS S3",
      "AWS MediaLive",
      "AWS CloudFront",
      "AWS CloudWatch",
    ],
  },
];

export const experiences = [
  {
    id: 1,
    role: "Software Engineer",
    company: "Intelivita Private Limited",
    duration: "June 2025 - February 2026",
    type: "current",
    responsibilities: [
      "Led MERN stack projects with end-to-end ownership, from development to deployment",
      "Collaborated directly with clients to gather requirements and deliver tailored solutions",
      "Worked with cross-functional teams to resolve bugs and optimize performance",
      "Ensured code quality, scalability, and maintainability through best development practices",
    ],
  },
  {
    id: 2,
    role: "Associate Software Developer",
    company: "Valuecoders Services LLP",
    duration: "October 2022 - June 2025",
    type: "past",
    responsibilities: [
      "Developed and maintained full-stack MERN applications",
      "Debugging, optimization, and seamless deployment workflows",
      "Version control management and coding standards compliance",
      "Collaborated with cross-functional teams for feature delivery",
    ],
  },
  {
    id: 3,
    role: "Freelance Developer",
    company: "Independent Freelancer",
    duration: "Freelance",
    type: "past",
    responsibilities: [
      "Built responsive web applications using Vue.js with modern JavaScript (ES6+)",
      "Developed scalable microservices architecture using Java and Spring Boot",
      "Designed RESTful APIs and managed Oracle Database optimization",
      "Delivered end-to-end solutions from client consultation to deployment",
      "Applied best practices for code quality, security, and performance optimization",
    ],
    techStack: ["Vue.js", "Java", "Spring Boot", "Microservices", "Oracle Database", "Docker"],
  },
];

export const projects = [
  {
    id: 1,
    title: "Dono",
    subtitle: "Creator Tipping Platform",
    tagline: "Solo-built creator tipping platform — live in production",
    duration: "May 2026 - Present",
    description:
      "Built and deployed a live creator-tipping platform enabling streamers to claim a personal link and receive tips with messages from their audience — taken solo from concept to production.",
    techStack: ["Next.js", "PostgreSQL", "PayU", "AWS EC2", "AWS S3"],
    highlights: [
      "Solo-built, end-to-end, from concept to production",
      "Username-based public creator profiles & auth",
      "PayU payment gateway for secure tip checkout",
      "Deployed on AWS EC2 with S3 file storage",
    ],
    icon: "Gift",
    color: "#22C55E",
    link: "https://donoapp.in",
    isLive: true,
    featured: true,
  },
  {
    id: 2,
    title: "We Move",
    subtitle: "Fitness Tracking App",
    tagline: "Fitness tracking app with personalized workouts and meal plans",
    duration: "July 2025 - February 2026",
    description:
      "Fitness tracking application with interactive dashboards, personalized bootcamps, workouts & meal plans for a seamless, data-driven user experience.",
    techStack: ["NestJS", "Next.js", "MongoDB", "TypeScript"],
    highlights: [
      "Interactive dashboards & progress tracking",
      "Personalized bootcamps & workouts",
      "Custom meal plan generation",
      "Real-time progress analytics",
    ],
    icon: "Dumbbell",
    color: "#DAFF01",
    link: "https://www.thewemoveproject.co.uk/",
  },
  {
    id: 3,
    title: "LiveStage",
    subtitle: "Live Streaming Platform",
    duration: "March 2023 - January 2024",
    description:
      "Built a live streaming platform for artists with real-time interactions and optimized video delivery.",
    techStack: ["React.js", "Node.js", "AWS MediaLive", "CloudFront", "CloudWatch"],
    highlights: [
      "Real-time live streaming for artists",
      "AWS MediaLive & CloudFront integration",
      "Optimized video streaming performance",
      "Real-time audience interactions",
    ],
    icon: "Video",
    color: "#DAFF01",
    link: "https://www.livestage.stream/",
  },
  {
    id: 4,
    title: "Expense Manager",
    subtitle: "Expense Management Application",
    duration: "December 2023 - January 2025",
    description:
      "Comprehensive expense & mileage claim system with credit card tagging and travel booking integration.",
    techStack: ["React.js", "Node.js", "MongoDB", "Express.js"],
    highlights: [
      "Expense & mileage claim system",
      "Credit card tagging & reimbursement",
      "Travel booking with expense logging",
      "Automated reporting dashboard",
    ],
    icon: "Receipt",
    color: "#7F4A8E",
    link: null,
  },
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

export const socialLinks = [
  { label: "GitHub", href: "https://github.com/maverick-adi", icon: "Github" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/aditya-aman-b27708152", icon: "Linkedin" },
  { label: "Email", href: "mailto:adityaaman22@gmail.com", icon: "Mail" },
];
